// @ts-nocheck


import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { RangePicker } from '../../../../../components/ui';

import {
  Filter,
  FilterButtonsContainer,
  FilterContainer,
  FilterItem,
  OrgUnitSelect,
  Selects } from
'./../../../../../components';
import Field from './../../../../../components/card/Field';

import { formatDateTimeToISOString } from './../../../../../lib/helpers';



const { ContractorSelect, EntityStatusSelect } = Selects;

const SpoilerContent = styled.div.withConfig({ displayName: "Filter__SpoilerContent", componentId: "sc-1fbpcxx-0" })(["padding:16px;"]);


















export default ({ filter, cleanFilter, applyFilter }) =>
<SpoilerContent>
    <FilterContainer>
      <Filter
      cleanFilter={cleanFilter}
      applyFilter={applyFilter}
      initialValues={filter}
      additionalFilter>

        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter,
        showAdditional,
        handleAdditional
      }) =>
      <>
            <FilterItem>
              <Field mBottomNone>
                <OrgUnitSelect
              size="small"
              placeholder="Подразделение"
              onChange={(value) => changeValue('orgUnitId', value)}
              value={values.orgUnitId} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RangePicker
              size="small"
              startDate={
              values.startDate ? moment.utc(values.startDate) : null
              }
              endDate={values.endDate ? moment.utc(values.endDate) : null}
              onChange={changeValue} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <EntityStatusSelect
              size="small"
              onChange={(value) => changeValue('status', value)}
              value={values.status} />

              </Field>
            </FilterItem>

            <FilterItem>
              <Field mBottomNone>
                <ContractorSelect
              size="small"
              onChange={(value) => changeValue('contractorId', value)}
              value={values.contractorId} />

              </Field>
            </FilterItem>

            <FilterButtonsContainer
          applyFilter={applyFilter}
          cleanFilter={cleanFilter}
          handleAdditional={handleAdditional}
          showAdditional={showAdditional} />

          </>
      }
      </Filter>
    </FilterContainer>
  </SpoilerContent>;
